import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { TableGrid } from '@C/TableGrid';
import services from '@C/Admin/Packages/_utils/data';
import DropLoaderLarge from '@C/Utils/DropLoaderLarge';
import { confirmAlert } from 'react-confirm-alert';
import { toast } from 'react-toastify';
import axios from 'axios';
import { authHeader } from '@H';

const col = [
  {
    name: 'Package',
    key: 'plan',
  },
  {
    name: 'Features',
    key: 'all',
    formatter(props) {
      return (
        <div className="package-features">
          <ul className="package-list">
            {props.modules.map((item, index) => (
              <li key={index}>{item.module}</li>
            ))}
          </ul>
        </div>
      );
    },
  },
];

const ExistingPackages = () => {
  const [existingPackages, setExistingPackages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getPackages();
    // eslint-disable-next-line
  }, []);

  const getPackages = () => {
    services
      .getPackages()
      .then((response) => {
        const tmp = response.data.data;
        setExistingPackages(tmp.filter((item) => item.is_valid));
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const confirmDelete = (item) => {
    confirmAlert({
      title: 'Confirm package deletion',
      message: 'Are you sure',
      buttons: [
        {
          label: 'Yes',
          onClick: () => deleteItem(item),
        },
        {
          label: 'No',
          onClick: () => false,
        },
      ],
    });
  };

  const deleteItem = (item) => {
    const headers = authHeader(1);
    axios
      .delete(
        `${process.env.API_URL}/subscription/subscription-package/?package_id=${item.uuid}`,
        {
          headers,
        },
      )
      .then(() => {
        toast.success('Package deleted successfully', {
          position: 'bottom-center',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
        });
        getPackages();
      })
      .catch((error) => {
        toast.error(error.response.data.message);
      });
  };

  const enabledActions = [
    {
      action: 'Delete',
      roles: ['Site Admin'],
    },
  ];

  return (
    <>
      <section className="widget full-width list-table">
        <header>
          <h3> Existing Packages </h3>
        </header>
        <main className="list-content">
          <div className="table-wrapper --full">
            {loading ? (
              <DropLoaderLarge />
            ) : (
              <TableGrid
                col={col}
                row={existingPackages}
                pagination="disabled"
                enableExport={false}
                onDelete={confirmDelete}
                enabledActions={enabledActions}
              />
            )}
          </div>
        </main>
      </section>
    </>
  );
};

export default ExistingPackages;
